import axios from 'axios'

// Create axios instance
const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:5000/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('token')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

// Auth API
export const authAPI = {
  login: (credentials) => api.post('/auth/login', credentials),
  signup: (userData) => api.post('/auth/signup', userData),
  logout: () => api.post('/auth/logout'),
  getMe: () => api.get('/auth/me'),
  updateProfile: (profileData) => api.put('/auth/profile', profileData),
  changePassword: (passwordData) => api.put('/auth/password', passwordData),
}

// Nutrition API
export const nutritionAPI = {
  search: (query, params = {}) => 
    api.get('/nutrition/search', { 
      params: { q: query, ...params } 
    }),
  getFood: (id) => api.get(`/nutrition/food/${id}`),
}

// Meal Plans API
export const mealPlansAPI = {
  getAll: (params = {}) => api.get('/mealplans', { params }),
  getById: (id) => api.get(`/mealplans/${id}`),
  create: (mealPlanData) => api.post('/mealplans', mealPlanData),
  update: (id, mealPlanData) => api.put(`/mealplans/${id}`, mealPlanData),
  delete: (id) => api.delete(`/mealplans/${id}`),
  getPublic: (params = {}) => api.get('/mealplans/public', { params }),
  getShared: (token) => api.get(`/mealplans/shared/${token}`),
  share: (id, expiresInDays) => 
    api.post(`/mealplans/${id}/share`, { expiresInDays }),
  addMealToDay: (id, date, mealData) => 
    api.post(`/mealplans/${id}/days/${date}/meals`, mealData),
  removeMealFromDay: (id, date, mealId) => 
    api.delete(`/mealplans/${id}/days/${date}/meals/${mealId}`),
}

// Users API
export const usersAPI = {
  getStats: () => api.get('/users/stats'),
  getPreferences: () => api.get('/users/preferences'),
  updatePreferences: (preferences) => 
    api.put('/users/preferences', preferences),
}

// Health check
export const healthAPI = {
  check: () => api.get('/health'),
}

export default api
